module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gray-back",
    staticStyle: {
      "padding": ".2rem 0 8rem 0"
    }
  }, [_c('van-notice-bar', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    attrs: {
      "text": "请填写真实可收件地址，以便后期邮寄培训班相关物料。"
    }
  }), _vm._v(" "), _c('van-form', {
    on: {
      "submit": _vm.onSubmit,
      "failed": _vm.onFailed
    }
  }, [_c('van-cell-group', [_c('van-field', {
    attrs: {
      "label": "场次",
      "input-align": "right",
      "readonly": ""
    },
    model: {
      value: (_vm.formData.saiqu_name),
      callback: function($$v) {
        _vm.$set(_vm.formData, "saiqu_name", $$v)
      },
      expression: "formData.saiqu_name"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "label": "单位",
      "input-align": "right"
    },
    model: {
      value: (_vm.formData.danwei),
      callback: function($$v) {
        _vm.$set(_vm.formData, "danwei", $$v)
      },
      expression: "formData.danwei"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "label": "联系人",
      "rules": [{
        required: true,
        message: '联系人不能为空'
      }],
      "error-message-align": "right",
      "input-align": "right",
      "clearable": "",
      "placeholder": "请输入联系人姓名"
    },
    model: {
      value: (_vm.formData.ldname),
      callback: function($$v) {
        _vm.$set(_vm.formData, "ldname", $$v)
      },
      expression: "formData.ldname"
    }
  }), _vm._v(" "), (false) ? _c('van-field', {
    attrs: {
      "rules": [{
        required: true,
        message: '请输入微信号'
      }],
      "error-message-align": "right",
      "label": "微信号",
      "input-align": "right",
      "clearable": "",
      "placeholder": "请输入微信号"
    },
    model: {
      value: (_vm.formData.weixin),
      callback: function($$v) {
        _vm.$set(_vm.formData, "weixin", $$v)
      },
      expression: "formData.weixin"
    }
  }) : _vm._e(), _vm._v(" "), _c('van-field', {
    attrs: {
      "rules": [{
        required: true,
        message: '请输入正确的手机号'
      }],
      "error-message-align": "right",
      "label": "手机",
      "input-align": "right",
      "clearable": "",
      "placeholder": "请输入手机"
    },
    model: {
      value: (_vm.formData.phone),
      callback: function($$v) {
        _vm.$set(_vm.formData, "phone", $$v)
      },
      expression: "formData.phone"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "label": "验证码",
      "rules": [{
        required: true,
        message: '请输入验证码'
      }],
      "error-message-align": "right",
      "input-align": "right",
      "clearable": "",
      "placeholder": "请输入验证码"
    },
    scopedSlots: _vm._u([{
      key: "button",
      fn: function() {
        return [_c('van-button', {
          attrs: {
            "native-type": "button",
            "size": "small",
            "type": "primary",
            "disabled": _vm.clockSecond > 0
          },
          on: {
            "click": _vm.getCode
          }
        }, [_vm._v(_vm._s(_vm.clockSecond > 0 ?
          '(' + _vm.clockSecond + 's)' : '获取验证码'))])]
      },
      proxy: true
    }]),
    model: {
      value: (_vm.formData.phonecode),
      callback: function($$v) {
        _vm.$set(_vm.formData, "phonecode", $$v)
      },
      expression: "formData.phonecode"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "rules": [{
        validator: _vm.validator.email,
        message: '请输入正确的邮箱'
      }],
      "error-message-align": "right",
      "label": "邮箱",
      "input-align": "right",
      "clearable": "",
      "placeholder": "请输入邮箱"
    },
    model: {
      value: (_vm.formData.email),
      callback: function($$v) {
        _vm.$set(_vm.formData, "email", $$v)
      },
      expression: "formData.email"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "readonly": "",
      "clickable": "",
      "name": "area",
      "value": _vm.formData.county ? (_vm.formData.province + '/' + _vm.formData.city + '/' + _vm.formData.county) : '',
      "input-align": "right",
      "label": "单位地区选择",
      "placeholder": "点击选择省市区"
    },
    on: {
      "click": function($event) {
        _vm.showArea = true
      }
    }
  }), _vm._v(" "), _c('van-popup', {
    attrs: {
      "position": "bottom"
    },
    model: {
      value: (_vm.showArea),
      callback: function($$v) {
        _vm.showArea = $$v
      },
      expression: "showArea"
    }
  }, [_c('van-area', {
    attrs: {
      "area-list": _vm.areaList,
      "value": _vm.formData.area
    },
    on: {
      "confirm": _vm.onAreaConfirm,
      "cancel": function($event) {
        _vm.showArea = false
      }
    }
  })], 1), _vm._v(" "), _c('van-field', {
    attrs: {
      "readonly": "",
      "clickable": "",
      "name": "area",
      "value": _vm.formData.county ? (_vm.formData.eprovince + '/' + _vm.formData.ecity + '/' + _vm.formData.ecounty) : '',
      "input-align": "right",
      "label": "收件地区选择",
      "placeholder": "点击选择省市区"
    },
    on: {
      "click": function($event) {
        _vm.showeArea = true
      }
    }
  }), _vm._v(" "), _c('van-popup', {
    attrs: {
      "position": "bottom"
    },
    model: {
      value: (_vm.showeArea),
      callback: function($$v) {
        _vm.showeArea = $$v
      },
      expression: "showeArea"
    }
  }, [_c('van-area', {
    attrs: {
      "area-list": _vm.areaList,
      "value": _vm.formData.earea
    },
    on: {
      "confirm": _vm.oneAreaConfirm,
      "cancel": function($event) {
        _vm.showeArea = false
      }
    }
  })], 1), _vm._v(" "), _c('van-field', {
    attrs: {
      "rules": [{
        required: true,
        message: '请输入详细地址'
      }],
      "error-message-align": "right",
      "label": "收件详细地址",
      "input-align": "right",
      "clearable": "",
      "placeholder": "请输入详细地址"
    },
    model: {
      value: (_vm.formData.address),
      callback: function($$v) {
        _vm.$set(_vm.formData, "address", $$v)
      },
      expression: "formData.address"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "savebtn"
  }, [_c('van-button', {
    staticStyle: {
      "width": "3rem"
    },
    attrs: {
      "color": "linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)",
      "size": "normal",
      "round": "",
      "disabled": _vm.saveLoading,
      "loading": _vm.saveLoading,
      "loading-text": "提交中..."
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("下一步")])], 1)], 1), _vm._v(" "), _c('LoginDialog', {
    attrs: {
      "show": _vm.loginShow
    },
    on: {
      "loginSuccess": _vm.loginSuccess,
      "loginCancel": _vm.loginCancel
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-61ba02cc","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/huiyi/HuiyiApplyFormStep1.vue
// module id = 2428
// module chunks = 0